module.exports = __webpack_public_path__ + "static/img/tag-coupon-used.72b4626.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/tag-coupon-used.png
// module id = 348
// module chunks = 7